const packages = [
    {
      name: "Photo Vocha",
      description: `<p><strong>¡Viaje a la diversión de la fotografía instantanea en 4 ruedas!</strong></p>
        <p>La Photo Vocha es más que un increíble retro Microbus Volkswagen modelo 75 en perfectas condiciones. Es una micro con photobooth incorporado donde quién al subir a bordo empezará su viaje a la diversión de la fotografía instantánea.</p>`,
      icon: "images/vocha-icon.svg",
      heroImage: "images/vocha/hero-photo-vocha.jpg",
      homeImage: "images/photobooth-grid.jpg",
      machineImage: "images/photoVocha@2x.png",
      galleryWorld: "PHOTO",
      gallery: [
        "images/vocha/fotos-eventos.jpg",
        "images/vocha/fotos-boda.jpg",
        "images/vocha/photobooth.jpg",
        "images/vocha/fotos-instantaneas.jpg",
        "images/vocha/cabina-fotografica.jpg",
        "images/vocha/fotos-divertidas.jpg",
      ]
    },
    {
        name: "Mirror Booth",
        description: `<p><strong>¡Espejito espejito quien sale más bonito!</strong></p>
          <p>Este no es el tradicional Photo Booth, sino un espejo generador de fotografías con lo último en tecnología.</p>
          <p>El Mirror Photo Booth ofrece un moderno diseño combinado con una interface amigable y muy divertida a través de una pantalla táctil y coloridas animaciones. Permite hasta 8 personas en el encuadre en un espacio completamente abierto. Se puede utilizar también con back panel para un estilo más lounge.</p>`,
        icon: "images/mirror-icon.svg",
        heroImage: "images/mirror/hero-mirror-booth.jpg",
        homeImage: "images/mirrorbooth-grid@2x.jpg",
        machineImage: "images/mirror-booth-machine@2x.png",
        galleryWorld: "BOOTH",
        gallery: [
            "images/mirror/bodas.jpg",
            "images/mirror/eventos-corporativos.jpg",
            "images/mirror/team-building.jpg",
            "images/mirror/fotos-bodas.jpg",
            "images/mirror/mirror-booth.jpg",
            "images/mirror/fotografias.jpg",
        ]
    },
    {
        name: "Open Air",
        description: `<p><strong>¡Infinitas posibilidades de diversión con el Photobooth abierto!</strong></p>
          <p>Hacé todas las muecas que querás con tu familia y amigos en este photobooth abierto o cerrado donde hasta 8 personas a la vez podrán llevarse consigo fabulosos recuerdos de la mejor  esta de sus vidas.</p>
          <p>Utilizamos un back panel (tela tensada) para crear un estilo lounge. Contamos con dos estilos: Led Luminoso o Totem Negro.</p>`,
        icon: "images/open-air-icon.svg",
        heroImage: "images/open/hero-open-air.jpg",
        homeImage: "images/open-air-grid@2x.jpg",
        machineImage: "images/open-air-machine@2x.png",
        galleryWorld: "OPEN",
        gallery: [
            "images/open/team-building.jpg",
            "images/open/open-air.jpg",
            "images/open/props-fotos.jpg",
            "images/open/fotos-eventos.jpg",
            "images/open/eventos-corporativos.jpg",
            "images/open/eventos-ninos.jpg",
        ]
    },{
        name: "Vintage Photo Booth",
        description: `<p><strong>¡Combina el look tradicional del photo booth (sentado y cerrado) con el fabuloso toque del estilo Vintage!</strong></p>
          <p>Este sistema cuenta con asientos para 2 personas ofreciendo fotografías con ese toque clásico de los Photo Booth pero con la comodidad de los modernos componentes de impresión.`,
        icon: "images/vintage-icon.svg",
        heroImage: "images/vintage/hero-vintage-photo.jpg",
        homeImage: "images/vintage-grid@2x.jpg",
        machineImage: "images/vintage-machine@2x.jpg",
        galleryWorld: "VINTAGE",
        gallery: [
            "image",
            "image",
            "image",
            "image",
            "image",
            "image",
        ]
    },
];
  
  export default packages;
  


// WEBPACK FOOTER //
// ./src/data/packages.js